import { render, staticRenderFns } from "./BaoCaoThongKe.vue?vue&type=template&id=27ffcf3e"
import script from "./BaoCaoThongKe.vue?vue&type=script&lang=js"
export * from "./BaoCaoThongKe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports